// extracted by mini-css-extract-plugin
module.exports = {"title":"ChanelBanner_title__59Q7K","banner":"ChanelBanner_banner__cAqlR"};